import React, { useCallback, useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import store from '../redux/store';
import ApplicationService from '../services/ApplicationService';
import { LoadProjectSkeleton } from '../utils/loadingComponents/LoadSkeleton';

const PrivateRoute = ({ path, component: Component, ...rest }: any) => {
  const {
    config: { ConstructionPortalUrl, apiBaseUrl }
  } = store.getState();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isError, setIsError] = useState<boolean>(false);

  const checkIsAuthenticated = useCallback(async () => {
    await ApplicationService.getUser('home')
      .then(() => {
        setIsAuthenticated(true);
      })
      .catch((err) => {
        if (err.response && err.response.status !== 401) {
          setIsAuthenticated(null);
          setIsError(true);
        } else setIsAuthenticated(false);
      });
  }, []);

  useEffect(() => {
    checkIsAuthenticated();
  }, [checkIsAuthenticated]);

  if (isAuthenticated !== null)
    return (
      <Route
        {...rest}
        render={({ location, ...props }) => { 
          const normalizeUrl = (url: string) =>
            decodeURIComponent(url).trim().toLowerCase();
            const isReferrerSameAsUrl = normalizeUrl(document.referrer) === normalizeUrl(document.URL);
          if (
            path === '/:projectName/portal' &&
            !ConstructionPortalUrl.split(',').includes(document.referrer) &&
              !isReferrerSameAsUrl
            //Request origin is not construction portal
          )
          {
          return <Redirect to='/unAuthorized' />;
          } else if (
            (path === '/:projectName/portal' &&
              ConstructionPortalUrl.split(',').includes(document.referrer)) || //First request from construction portal requires being passed to server
            !isAuthenticated
          ) {
            globalThis.location.replace(`${apiBaseUrl}/login`);
            return null;
          } else return <Component {...props} />;
        }}
      />
    );
  else if (isError === true) return <h3>Something went wrong.</h3>;
  else if(!isAuthenticated && path === '/:projectName/viewer') return <LoadProjectSkeleton />
  return null;
};

export default PrivateRoute;
